import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'
import Home from '@/pages/Home/Home'
import Community from '@/pages/Community/Community'
import Integral from '@/pages/Integral/Integral'
import User from '@/pages/User/User'
import Photo from '@/pages/Photo/Photo'
import Block from '@/pages/Block/Block'
import IntDetails from '@/pages/IntDetails/IntDetails'
import Exchange from '@/pages/Exchange/Exchange'
import MyPhoto from '@/pages/MyPhoto/MyPhoto'
import Lately from '@/pages/Lately/Lately'
import ResetInfo from '@/pages/ResetInfo/ResetInfo'
import Sign from '@/pages/Sign/Sign'
import Dial from '@/pages/Dial/Dial'
import Article from '@/pages/Article/Article'
import BlockList from '@/pages/BlockList/BlockList'
import PhotoDetail from '@/pages/PhotoDetail/PhotoDetail'
import Post from '@/pages/Post/Post'
import Edit from '@/pages/Post/Edit'


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      component: App,
      redirect: 'home',
    },
    {
      path: '/home',
      component: Home,
      meta: {
        showFooter: true
      }
    },
    {
      path: '/community',
      component: Community,
      meta: {
        showFooter: true
      }
    },
    {
      path: '/integral',
      component: Integral,
      meta: {
        showFooter: true
      }
    },
    {
      path: '/user',
      component: User,
      meta: {
        showFooter: true
      }
    },
    {
      path: '/photo',
      component: Photo
    },
    {
      path: '/photo/:catid',
      component: Photo
    },
    {
      path: '/block',
      component: Block
    },
    {
      path: '/intdetails/:tid',
      component: IntDetails
    },
    {
      path: '/exchange',
      component: Exchange
    },
    {
      path: '/myphoto',
      component: MyPhoto
    },
    {
      path: '/lately',
      component: Lately
    },
    {
      path: '/resetinfo',
      component: ResetInfo
    },
    {
      path: '/sign',
      component: Sign
    },
    {
      path: '/dial',
      component: Dial
    },
    {
      path: '/article/:tid',
      component: Article
    },
    {
      path: '/blocklist/:fid',
      component: BlockList
    },
    {
      path: '/photodetail/:id',
      component: PhotoDetail
    },
     {
      path: '/post/:fid',
      component: Post
    },
    {
      path: '/edit/:tid',
      component: Edit
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js